import { QueryKey } from '@/lib/query-client';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import ListToggle from '../list-toggle';
import { FormProps } from '../helpers';
import { UiOption } from '@/lib/helpers';
import useQueryHelper from '@/hooks/use-query-helper';
import { getAllAgents } from '@/lib/services/agent.service';
import AgentLink from '@/components/agent-link';

interface Props extends FormProps {
  value: string[];
  onChange: (options: UiOption[]) => void;
}

const AgentsListToggle: FC<Props> = (props) => {
  const query = useQuery([QueryKey.AgentsList], async () => getAllAgents());
  const { data: agents } = query;
  const { showLoader } = useQueryHelper(query);

  const agentOptions = useMemo(() => {
    return (agents || []).map((agent) => ({
      value: agent.id,
      label: <AgentLink agent={agent} showAdminName />,
    }));
  }, [agents]);

  return (
    <ListToggle
      {...props}
      options={agentOptions}
      leftTitle="Available Assistants"
      rightTitle="Assigned Assistants"
      loadState={showLoader ? 'loading' : 'loaded'}
    />
  );
};

export default AgentsListToggle;
